import React, { Component } from "react";
import { Form, Spinner, Image } from "react-bootstrap";
import CrossIcon from "../../../assets/cross_icon.png";
import QuickFilter from "../../FilterComponent/QuickFilter";

class QuickFilterSearch extends Component {
  debounce = null;

  onChange = e => {
    const {
      keyName,
      onChange,
      debounceTime = 1000,
      callAfterDebounce,
      
    } = this.props;
    const { value } = e.target;
    onChange && onChange(e, { name: keyName, value });
   
    this.debounce && clearTimeout(this.debounce);
    this.debounce = setTimeout(() => {
      callAfterDebounce && callAfterDebounce({ name: keyName, value });
    }, debounceTime);
   
  };

  filtersInFilterComponent = filterListInFilterComponent => {
    const { onSelectingFilter } = this.props;
    onSelectingFilter(filterListInFilterComponent);
  };

  render() {
    const { props, onChange } = this;

    const {
      loader = true,
      classes = "",
      isLoading = false,
      loaderSrc = "",
      value = "",
      isSearchingUsers,
      isSearchingBestPractice,
      isSearchingIssue,
      filterList,
      getFilterId,
      makeSelectedNull,
      isFromMisSection,
      activeReport,
      onSelectingFilterInSearchComponent
    } = props;
    return (
      <div className={`search-container-component-new ${classes}`}>
        <Form.Control
          {...props}
          type="text"
          className="search-field"
          onChange={onChange}
          //value={this.props.searchedtext}
        />
         <span style={{marginLeft:"-6%",cursor:"pointer",display:this.props.searchedtext==""?"none":null}}>
          <img src={CrossIcon} alt="Clear search" />
        </span>
        {<span className="search-container-icon" />}
     
        {loader &&
        (isSearchingBestPractice === true ||
          isSearchingUsers === true ||
          isSearchingIssue === true) ? (
          <div className="search-container-spinner">
            <QuickFilter
              filterList={filterList}
              getFilterId={getFilterId}
              makeSelectedNull={makeSelectedNull}
              isUserFilter={true}
              isFromMisSection={isFromMisSection}
              activeReport={activeReport}
              onSelectedFilter={this.filtersInFilterComponent}
            />
             
            
          </div>
        ) : (
          <div className="search-container-spinner">
            {isLoading ? (
              <Spinner animation="border" variant="secondary" />
            ) : null}
          </div>
        )}
      </div>
    );
  }
}

export { QuickFilterSearch };
